import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import { InputControls } from 'components/common'
import Tooltip from './Tooltip'
import { getStaticImage } from 'utils/statics'

const Toggle = ({ label, value, onChange, isRequired, error }) => (
  <div className='smartchat-field toggle'>
    {label && (
      <div className='smartchat-field__header'>
        {label && <label>{label}</label>}
        <span>{isRequired ? `(${I18n.t('dashboard_required')})` : `(${I18n.t('dashboard_optional')})`}</span>
      </div>
    )}
    <div className='smartchat-field__body'>
      <InputControls
        injectType='external'
        value={value}
        onChange={onChange}
        color={!error ? 'primary' : 'error'}
      />
      {typeof error === 'string' ? (
        <Tooltip
          icon={getStaticImage('/icons/orange-brand/icon-warning-yellow.svg')}
          message={error}
        />
      ) : null}
    </div>
  </div>
)

export default Toggle
